export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11147.c92e193f.jpg";